import { ShowingRequestStatus } from '../interfaces/showing-request-status.enum';
import { ShowingDto } from '../interfaces/showing.interface';

export function getPendingShowings(showings: ShowingDto[]) {
  return showings.filter(({ showingRequests }) => {
    return showingRequests.some(({ status }) => status === ShowingRequestStatus.PENDING);
  });
}
